import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import BrandPreview from './components/BrandPreview';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Quanzhou Yunxin Outdoor Products Co., Ltd.',
      alternateName: 'YUNXIN OUTDOOR',
      url: SITE_URL,
      logo: `${SITE_URL}/vite.svg`,
      description: 'Professional manufacturer of premium tool bags and organizer bags. 15+ years of excellence, 200+ models, trusted by professionals in 50+ countries.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'No.6 Sunshine Road, Xiamei Town',
        addressLocality: "Nan'an City",
        addressRegion: 'Fujian Province',
        addressCountry: 'CN',
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+86-137-9029-6151',
          contactType: 'sales',
          email: 'andy-zou@qzyunxin.com',
          availableLanguage: ['English', 'Chinese'],
        },
      ],
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: 'YUNXIN OUTDOOR',
      description: 'Premium Tool Bags & Organizer Bags Manufacturer',
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${SITE_URL}/#localbusiness`,
      name: 'Quanzhou Yunxin Outdoor Products Co., Ltd.',
      image: `${SITE_URL}/vite.svg`,
      url: SITE_URL,
      telephone: '+86-137-9029-6151',
      email: 'andy-zou@qzyunxin.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'No.6 Sunshine Road, Xiamei Town',
        addressLocality: "Nan'an City",
        addressRegion: 'Fujian Province',
        addressCountry: 'CN',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 24.95,
        longitude: 118.38,
      },
      priceRange: '$$',
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.text = JSON.stringify(homeSchema);
    document.head.appendChild(script);
    document.title = 'YUNXIN OUTDOOR | Premium Tool Bags & Organizer Bags Manufacturer';
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProducts />
        <BrandPreview />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
